import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@lib/queryKeys';
import { fetchAccommodationGuests } from '@/renderer/services/accommodationService';

export function useAccommodationGuests(outletId: string | null | undefined) {
  return useQuery({
    queryKey: queryKeys.accommodation.guests(outletId),
    queryFn: () => fetchAccommodationGuests(outletId ?? undefined),
  });
}
